"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SOURCE_ITEMS_PAGE_SIZE = void 0;
/** Page size of a source's items viewer (`GET /sources/:id/items/page`). */
exports.SOURCE_ITEMS_PAGE_SIZE = 50;
//# sourceMappingURL=source.js.map